module.exports = __webpack_public_path__ + "static/media/appstore.14c4763d.svg";